import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";

const PermissionTable = ({
  headerData,
  Data,
  TablePagination,
  onChange,
  isCheckedFlag,
  isDisabled = false,
}) => {
  const [isChecked, setIsChecked] = useState(isCheckedFlag);
  return (
    <TableContainer
      className="rounded-2xl bg-white"
      style={{
        boxShadow: "0px 0px 10px rgba(235, 234, 234, 0.1)",
        border: "0.5px solid #fafafa",
        borderRadius: "10px",
      }}
      component={Paper}
    >
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead
          sx={{
            fontFamily: "monospace",
            backgroundColor: "#F5F5F7",
            color: "#4C4E64",
          }}
        >
          <TableRow>
            <TableCell align="center" width="5%">
              No
            </TableCell>
            {headerData.map((header, index) => (
              <TableCell
                key={index}
                align={header.align}
                style={{ width: header.width }}
              >
                {header.label}
              </TableCell>
            ))}
            <TableCell align="center" width="15%">
              Tambah Data
            </TableCell>
            <TableCell align="center" width="15%">
              Ubah Data
            </TableCell>
            <TableCell align="center" width="15%">
              Hapus Data
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {Data?.length > 0 ? (
            Data.map((row, index) => (
              <TableRow key={index}>
                <TableCell align="center" width="5%">
                  {index + 1}
                </TableCell>

                {headerData.map((data, index) => (
                  <TableCell align={data.align} width={data.width} key={index}>
                    {row[data.key]}
                  </TableCell>
                ))}

                <TableCell align="center" width="15%">
                  <div>
                    <input
                      id={row.key}
                      type="checkbox"
                      className="h-5 w-5"
                      disabled={isDisabled}
                      checked={
                        isChecked?.hasOwnProperty(row.key)
                          ? isChecked[row.key]?.addData
                          : false
                      }
                      onChange={(event) => {
                        const updatedIsChecked = {
                          ...isChecked, // Salin state lama
                          [row.key]: {
                            ...isChecked[row.key], // Salin properti objek jika ada
                            addData: event.target.checked, // Perbarui properti addData
                          },
                        };
                        setIsChecked(updatedIsChecked); // Perbarui state
                        onChange(updatedIsChecked);
                      }}
                    />
                  </div>
                </TableCell>
                <TableCell align="center" width="15%">
                  <div>
                    <input
                      id={row.key}
                      type="checkbox"
                      className="h-5 w-5"
                      disabled={isDisabled}
                      checked={
                        isChecked?.hasOwnProperty(row.key)
                          ? isChecked[row.key].updateData
                          : false
                      }
                      onChange={(event) => {
                        const updatedIsChecked = {
                          ...isChecked, // Salin state lama
                          [row.key]: {
                            ...isChecked[row.key], // Salin properti objek jika ada
                            updateData: event.target.checked, // Perbarui properti addData
                          },
                        };
                        setIsChecked(updatedIsChecked); // Perbarui state
                        onChange(updatedIsChecked);
                      }}
                    />
                  </div>
                </TableCell>
                <TableCell align="center" width="15%">
                  <div>
                    <input
                      id={row.key}
                      type="checkbox"
                      className="h-5 w-5"
                      disabled={isDisabled}
                      checked={
                        isChecked?.hasOwnProperty(row.key)
                          ? isChecked[row.key].deleteData
                          : false
                      }
                      onChange={(event) => {
                        const updatedIsChecked = {
                          ...isChecked, // Salin state lama
                          [row.key]: {
                            ...isChecked[row.key], // Salin properti objek jika ada
                            deleteData: event.target.checked, // Perbarui properti addData
                          },
                        };
                        setIsChecked(updatedIsChecked); // Perbarui state
                        onChange(updatedIsChecked);
                      }}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                style={{
                  height: 100,
                }}
                colSpan={headerData.length + 2}
                align="center"
              >
                <p
                  className="text-sm"
                  style={{
                    fontFamily: "Poppins",
                  }}
                >
                  Tidak Ada Data
                </p>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {TablePagination}
    </TableContainer>
  );
};

export default PermissionTable;
